module.exports = __webpack_public_path__ + "static/media/life-ring.780ab24d.svg";